<script lang="ts">
  import { cn } from "$lib/utils";
  import { HoverCard, HoverCardContent, HoverCardTrigger } from "$lib/components/ui/hover-card";
  import type { SearchResult } from "$lib/types";
  import { parseCriteria, sortByCriteriaMatch } from "./helpers";

  let { result, rowIndex, selectedCell, colIndex, onClick } = $props<{
    result: SearchResult;
    selectedCell: { row: number | null; col: number | null };
    colIndex: number;
    onClick: (e: MouseEvent) => void;
  }>();

  let sortedCriteria = $derived(result.criteriaAndReasons ? sortByCriteriaMatch(result.criteriaAndReasons) : []);
</script>

<div class="pointer-events-none flex flex-col gap-0.5">
  <!-- First two criteria -->
  {#each sortedCriteria.slice(0, 2) ?? [] as cr}
    {#if cr.isMatch === "match" || sortedCriteria.length === 2}
      <div class="flex items-center gap-1">
        <span
          class={cn(
            "text-xs font-medium",
            cr.isMatch === "match" ? "text-green-600 dark:text-theme-green" : "text-gray-300 dark:text-gray-600",
          )}
        >
          {cr.isMatch === "match" ? "✓" : "✗"}
        </span>
        <span
          class={cn(
            "truncate text-xs text-gray-600 dark:text-gray-400",
            selectedCell.row === rowIndex && selectedCell.col === colIndex ? "" : "",
          )}
        >
          {parseCriteria(cr)}
        </span>
      </div>
    {/if}
  {/each}

  <!-- Hover card with indicators -->
  {#if (sortedCriteria.length ?? 0) > 2}
    <HoverCard openDelay={50} closeDelay={0} ignoreNonKeyboardFocus={true}>
      <button onclick={onClick} class="w-fit">
        <HoverCardTrigger class="pointer-events-auto">
          <div class="flex w-fit items-center gap-1.5">
            <span
              class={cn(
                "w-fit cursor-pointer !rounded-base text-xs text-gray-500 hover:text-theme-text-primary",
                selectedCell.row === rowIndex && selectedCell.col === colIndex ? "" : "",
              )}
            >
              <div class="inline-flex w-fit gap-0.5">
                {#each sortedCriteria as cr}
                  <div
                    class={cn(
                      "h-1.5 w-1.5 rounded-sm",
                      cr.isMatch === "match" ? "bg-green-600 dark:bg-theme-green" : "bg-gray-300 dark:bg-gray-600",
                    )}
                  ></div>
                {/each}
              </div>
            </span>
          </div>
        </HoverCardTrigger>
      </button>
      <HoverCardContent
        class="w-80 !rounded-base border border-gray-200 bg-white p-2 shadow-lg dark:border-white/30 dark:bg-theme-background-secondary"
      >
        <div class="flex flex-col gap-2">
          {#each sortedCriteria as cr}
            <div class="flex items-center gap-2">
              <span
                class={cn(
                  "text-xs font-medium",
                  cr.isMatch === "match" ? "text-green-600 dark:text-theme-green" : "text-gray-300 dark:text-gray-600",
                )}
              >
                {cr.isMatch === "match" ? "✓" : "✗"}
              </span>
              <span class="text-xs text-gray-600 dark:text-gray-400">
                {parseCriteria(cr)}
              </span>
            </div>
          {/each}
        </div>
      </HoverCardContent>
    </HoverCard>
  {/if}
</div>
